// Coluna "Pessoa" da planilha de acesso — mesmo padrão visual do avatar
// redondo já usado em UsersPage.jsx e no PersonCell do quadro.
export default function AccessPersonCell({ user }) {
  const initials = user?.name
    ? user.name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2)
    : '?';
  return (
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center text-xs font-semibold shrink-0 overflow-hidden">
        {user?.avatar_url ? (
          <img src={user.avatar_url} alt={user.name} className="w-full h-full object-cover" />
        ) : (
          initials
        )}
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <span className="text-sm text-text-primary truncate">{user?.name}</span>
          {user?.active === false && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-text-secondary/15 text-text-secondary font-medium shrink-0">
              Inativa
            </span>
          )}
        </div>
        <div className="text-xs text-text-secondary truncate">{user?.email}</div>
      </div>
    </div>
  );
}
